const DATA_API_BASE_URL = import.meta.env.VITE_DATA_API_BASE_URL || '/api';

export type DashboardDataType =
  | 'business_profile'
  | 'badge_definitions'
  | 'energy_overview'
  | 'energy_insights'
  | 'usage_forecast'
  | 'carbon_impact'
  | 'seasonal_insights'
  | 'peak_demand'
  | 'anomalies'
  | 'operational_hours'
  | 'efficiency_metrics';

export const fetchDashboardData = async <T>(
  businessId: string,
  dataType: DashboardDataType | string
): Promise<T> => {
  const url = `${DATA_API_BASE_URL}/data/${encodeURIComponent(businessId)}/${encodeURIComponent(dataType)}`;
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch ${dataType} for ${businessId}`);
  }

  const data = await response.json();

  if (data && typeof data === 'object' && 'payload' in data) {
    return data.payload as T;
  }

  return data as T;
};
